"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Eleanor & Julian",
  quote: "Ivory Lens didn't just take photos; they captured the very soul of our day with such grace and soft, ethereal light.",
  position: "Married in Tuscany"
}, {
  author: "Sophia & Marcus",
  quote: "The attention to detail and the way they use natural light is simply breathtaking. Our album is a timeless treasure.",
  position: "Married in Provence"
}];
export default function GuestChronicles() {
  return <section data-section-id="238174" id="love-notes" className="relative w-full bg-background text-foreground py-24 md:py-32 overflow-hidden flex flex-col items-center justify-center min-h-[80vh]">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[12vw] md:text-[15vw] font-default font-light leading-none text-primary/[0.03] whitespace-nowrap italic">
          Timeless Moments
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-5xl">
        <div className="text-center mb-16 md:mb-24">
          <span className="font-sans text-xs font-semibold tracking-[0.4em] uppercase text-muted-foreground">
            Kind Words
          </span>
        </div>

        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-6 md:px-20 lg:px-32">
                  <p className="font-default italic text-3xl md:text-5xl lg:text-6xl leading-tight md:leading-snug text-foreground mb-10 md:mb-16 tracking-tight">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-8 h-[1px] bg-accent mb-4"></div>
                    <span className="font-sans uppercase tracking-[0.3em] text-sm md:text-base font-medium text-foreground">
                      {testimonial.author}
                    </span>
                    <span className="font-sans text-xs md:text-sm tracking-widest text-muted-foreground uppercase">
                      {testimonial.position}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex items-center justify-center gap-6 mt-16 md:mt-24">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-12 border-border rounded-md hover:bg-accent hover:text-accent-foreground transition-all duration-500 shadow-sm" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-12 border-border rounded-md hover:bg-accent hover:text-accent-foreground transition-all duration-500 shadow-sm" />
          </div>
        </Carousel>
      </div>
    </section>;
}